import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SliderPlaceholder from './SliderPlaceholder';

import './SliderTrackImage.scss';

const loadedSrcImages = new Map();

class SliderTrackImage extends Component {
  static getDerivedStateFromProps(props) {
    if (!props.item || !loadedSrcImages.get(props.item.src)) {
      return { imageLoaded: false };
    }
    return { imageLoaded: true };
  }

  handleLoad = () => {
    this.setState({ imageLoaded: true });
    loadedSrcImages.set(this.props.item.src, true);
  };

  render() {
    const className = classNames('slider-figure', {
      'slider-figure--hidden': !this.state.imageLoaded
    });

    const { item } = this.props;

    return item ? (
      <div className="slider-figure__wrapper">
        {!this.state.imageLoaded && <SliderPlaceholder size="desktop" />}
        <figure className={className}>
          <picture className="slider-figure__image">
            <source
              type="image/webp"
              srcSet={item.src.replace('.jpg', '.webp')}
            />
            <source type="image/jpeg" srcSet={item.src} />
            <img alt={item.caption} onLoad={this.handleLoad} />
          </picture>
          <figcaption>{item.caption}</figcaption>
        </figure>
      </div>
    ) : null;
  }
}

SliderTrackImage.propTypes = {
  item: PropTypes.shape({
    src: PropTypes.string.isRequired,
    caption: PropTypes.string.isRequired
  }).isRequired
};

export default SliderTrackImage;
